<template>
  <div class="footer-btns">
    <template v-if="service?.examine === 'PENDING'">

      <el-button @click="examine(0)">审核驳回</el-button>
      <el-dropdown>
        <el-button type="primary">
          审核通过<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="examine(1,true)">审核通过直接发布</el-dropdown-item>
          <el-dropdown-item @click.native="examine(1,false)">仅审核通过</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </template>

    <template v-else>
      <el-button @click="examine(null)">撤销审核</el-button>
      <el-button v-if="!service?.onSale" plain type="primary" @click="toPublish(true)">发布</el-button>
      <el-button v-else plain type="danger" @click="toPublish(false)">下架</el-button>
    </template>

  </div>
</template>

<script>
import {miuTeacherService} from "@/api/miu/teacherService";

export default {
  name: 'TeacherServiceExamineBtn',

  props: {
    service: Object,
  },

  methods: {
    toPublish(publish) {
      let str = publish ? '发布' : '下架';

      this.$confirm("确定" + str + "吗？").then(() => {
        miuTeacherService.publish(this.service.id, publish).then(res => {
          this.$message.success(str + "成功");
          this.$emit("examined");
        })
      })
    },

    examine(code, publish = false) {
      // 审批通过
      if (code === 1) {
        this.$confirm("确定通过审核吗？").then(() => {
          miuTeacherService.examine(this.service.id, 'APPROVED').then(res => {
            this.$message.success("审核成功");

            miuTeacherService.publish(this.service.id, publish).then(res => {
              this.$message.success("发布成功");
            })

            this.$emit("examined");
          });
        })
      }
      // 审批驳回
      else if (code === 0) {
        this.$prompt("请输入驳回理由", "驳回理由", {}).then(({value}) => {
          miuTeacherService.examine(this.service.id, 'REJECTED', value).then(() => {
            this.$message.success("审核成功");
            this.$emit("examined");
          })
        })
      }

      // 撤销审核
      else if (code === null) {
        this.$confirm("确定撤销审核吗？该记录将还原到未审核状态！").then(() => {
          miuTeacherService.examine(this.service.id, 'PENDING', null).then(() => {
            this.$message.success("审核成功");

            this.$emit("examined");
          })
        })
      }
    },
  },


}
</script>

<style scoped>
.footer-btns {
  display: flex;
  justify-items: center;
  gap: 12px;
  justify-content: center;
}
</style>